import React, { lazy, Suspense } from "react";
import "./App.css";
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
// import CreativeBuilder from "./Creativebuilder/IndexWrapper";
import AppHub from "./Hub";
import { LinearProgress, ThemeProvider, createTheme } from "@mui/material";
import AuthWall from "Login/AuthWall";
import { AuthProvider } from "Login/AuthContext";

const LayoutLogin = lazy( () => import( "./Layout/Login" ) );
const LoginPage = lazy( () => import( "Login/LoginPage" ) );
const Layout = lazy( () => import( "./Layout" ) );
const LoginPageCallback = lazy( () => import( "Login/LoginPageCallback" ) );
const CreativeBuilder = lazy( () => import( "./Creativebuilder/IndexWrapper" ) );
const CreativeBuilderEdit = lazy( () => import( "./Creativebuilder/Edit" ) );
const CreativeBuilderAll = lazy( () => import( "./Creativebuilder/All" ) );
const TemplateBuilder = lazy( () => import( "./TemplateBuilder/IndexWrapper" ) );
const TemplateBuilderEdit = lazy( () => import( "./TemplateBuilder/Edit" ) );
const TemplateBuilderAll = lazy( () => import( "./TemplateBuilder/All" ) );

const theme = createTheme({
  typography: {
    htmlFontSize: 19
  },
  palette: {
    black: {
      main: "#000000",
      light: "#6f6f6fff",
      dark: "#3b3b3bff",
      contrastText: "#ffffffff",
    }
  }
});

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        id="root"
        path="/"
        element={<AppHub/>}
      />
      <Route
        id="login"
        path="/login"
        element={<LayoutLogin/>}
      >
        <Route
          path=""
          index
          element={<LoginPage/>}
          handle={{
            title: "Login",
            pageType: "all"
          }}
        ></Route>
        <Route
          path="callback"
          index
          element={<LoginPageCallback/>}
          handle={{
            title: "Login",
            pageType: "all"
          }}
        ></Route>
      </Route>
      <Route element={<AuthWall/>}>
        <Route
          path="/view"
          element={<Layout
          />}
          handle={{
            title: "Creative AI"
          }}
        >
          <Route
            path="creativebuilder"
            element={<CreativeBuilder
              title="Creative Builder"
            />}
            handle={{
              title: "Creative Builder",
              pageType: "all"
            }}
          >
            <Route
              path=""
              index
              // element={<CreativeBuilderAll/>}
              element={<Suspense fallback={<LinearProgress/>}>
                <CreativeBuilderAll
                  tutorials={[
                    {
                      id: "searchfilters",
                      target: "search-filters-accordion",
                      text: "Looking for your campaigns? Try these filters.",
                      placement: "top-start",
                    },
                    {
                      id: "newcampaignbutton",
                      target: "new-campaign-button",
                      text: "Click here to start a new Campaign.",
                      placement: "left-start",
                    },
                  ]}
                />
              </Suspense>}
              handle={{
                title: "Campaigns",
                pageType: "all"
              }}
            />
            <Route
              path="edit/"
              // element={<CreativeBuilderEdit/>}
              // lazy={() => import( "./Creativebuilder/Edit" )}
              element={<Suspense fallback={<LinearProgress/>}>
                <CreativeBuilderEdit/>
              </Suspense>}
              handle={{
                title: "New Campaign",
                pageType: "edit"
              }}
            />
            <Route
              path="edit/:_id"
              // element={<CreativeBuilderEdit/>}
              // lazy={() => import( "./Creativebuilder/Edit" )}
              element={<Suspense fallback={<LinearProgress/>}>
                <CreativeBuilderEdit/>
              </Suspense>}
              handle={{
                title: "Edit Campaign",
                pageType: "edit"
              }}
            />
          </Route>
          <Route
            path="templatebuilder"
            element={<TemplateBuilder
              title="Template Builder"
            />}
            handle={{
              title: "Template Builder",
              pageType: "hub"
            }}
          >
            <Route
              path=""
              index
              element={<Suspense fallback={<LinearProgress/>}>
                <TemplateBuilderAll/>
              </Suspense>}
              handle={{
                title: "All Templates",
                pageType: "all"
              }}
            />
            <Route
              path="edit/"
              element={<Suspense fallback={<LinearProgress/>}>
                <TemplateBuilderEdit/>
              </Suspense>}
              handle={{
                title: "New Template",
                pageType: "edit"
              }}
            />
            <Route
              path="edit/:_id"
              element={<Suspense fallback={<LinearProgress/>}>
                <TemplateBuilderEdit/>
              </Suspense>}
              handle={{
                title: "Edit Template",
                pageType: "edit"
              }}
            />
          </Route>
        </Route>
      </Route>
    </>
  )
);
function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <AuthProvider>
          <RouterProvider router={router}/>
        </AuthProvider>
      </div>
    </ThemeProvider>
  );
}

export default App;
